import axios from './index'

class account {


    static addAccount(params) {
        return axios.post(`/app-admin/account/create`,params)
    }
    
    static accountList(params) {
        return axios.get(`/app-admin/account`,{params:params})
    }
    //编辑账号
    static accountEdit(params) {
        return axios.post(`/app-admin/account/updateAccount`,params)
    }

    //账号开关
    static switchState(adminId) {
        return axios.get(`/app-admin/account/switchState/${adminId}`)
    }
   
}

export default account;
